import { WithList, WithPagination } from '@bv/api/crud';
import { mixinClass } from '@bv/utils';

import { userType } from '@bvai/types/user';

class UsersApi extends mixinClass(WithList<userType>, WithPagination<userType>) {
  public constructor(public endpoint = 'iam/users') {
    super(endpoint);
  }
}

export const usersApi = new UsersApi();
